import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { hexToRGB } from '../../utils';
import { CAROUSEL_ARROW_WIDTH } from './constants';
const carouselArrowStatePartialCSS = ({ theme, disabled, light, }) => {
    const color = light
        ? theme.colors.backgrounds.content.text[1]
        : theme.colors.backgrounds.primaryNavigation.text[1];
    const backgroundColor = light
        ? theme.colors.backgrounds.heading.background
        : theme.colors.backgrounds.secondaryNavigation.background;
    const backgroundOpacity = 0.6;
    return css `
    color: ${disabled ? hexToRGB(color, 0.2) : color};

    ${!disabled &&
        `
      &:hover,
      &:active {
        background-color: ${hexToRGB(backgroundColor, backgroundOpacity)};
      }
    `}
  `;
};
const StyledCarouselArrow = styled.button `
  align-items: center;
  display: flex;
  display: -webkit-box;
  justify-content: center;
  width: ${CAROUSEL_ARROW_WIDTH}px;
  flex-shrink: 0;
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${carouselArrowStatePartialCSS}
`;
export default StyledCarouselArrow;
